<template>
    <access-denied v-if="accessDenied" title="conta-corrente" />
    <div id="main" v-else>
        <Loader v-if="isLoading" />
        <div class="page">
            <AlertContainer :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">{{ $t("adicionar-saldo") }}</h1>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="showConfirmModal"
                        >
                            {{ $t("voltar") }}
                        </button>
                        <button
                            v-if="permissao.create && !integracao"
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t("salvar") }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div
                            class="column is-12 is-flex is-flex-column is-flex-hright g-1"
                        >
                            <p>
                                <strong>Empresa: </strong>
                                {{ contaFlex.nomeEmpresa }}
                            </p>
                            <p>
                                <strong>Colaborador: </strong>
                                {{ contaFlex.nomeUsuario }}
                            </p>
                        </div>
                        <div class="column is-12">
                            <vss-select
                                ref="motivoSelected"
                                required
                                title="motivo-lancamento"
                                v-model="motivoSelected"
                                :invalid="isNull(motivoSelected)"
                                :options="motivoList"
                                :loading="motivoLoading"
                                @search="carregarMotivo"
                                :placeholder="'selecione-uma-opcao'"
                            />
                        </div>
                        <div class="column is-12">
                            <v-money
                                ref="valorInput"
                                title="valor"
                                required
                                msg="msg-campo-obrigatorio"
                                v-model="flexLancamento.saldoGerado"
                                :invalid="isNull(flexLancamento.saldoGerado)"
                                :max="9999999"
                                :min="-9999999"
                                :disabled="isSaving"
                                :tooltipLabel="'tooltip-valor-saldo-conta-corrente'"
                                :tooltipPosition="'is-right'"
                                :tooltipType="'is-dark'"
                                :tooltipSize="'is-large'"
                                tooltipMultilined
                            />
                        </div>
                        <div
                            class="column is-12"
                            v-show="
                                motivoSelected
                                    ? motivoSelected.habilitaobrigaobservacao ==
                                          1 ||
                                      motivoSelected.habilitaobrigaobservacao ==
                                          2
                                    : false
                            "
                        >
                            <v-textarea
                                ref="observacaoInput"
                                v-model="flexLancamento.observacao"
                                title="observacao"
                                :rows="4"
                                :maxRows="6"
                                :invalid="
                                    motivoSelected && motivoSelected.habilitaobrigaobservacao == 2
                                        ? isNull(flexLancamento.observacao)
                                        : false
                                "
                                :required="
                                    motivoSelected
                                        ? motivoSelected.habilitaobrigaobservacao ==
                                          2
                                        : false
                                "
                                :disableTransform="true"
                                :disabled="isSaving"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MotivoService from "@/services/agro/MotivoService.js";
import FlexLancamentoService from "@/services/vendas/financeiro/FlexLancamentoService.js";
import FlexLancamentoValidation from "@/services/validations/financeiro/flex/FlexLancamentoValidation.js";
import Loader from "@/components/content/loader/Loader.vue";
import AlertContainer from "@/components/shared/AlertContainer.vue";

export default {
    name: "FlexManage",
    components: {
        Loader,
        AlertContainer,
    },
    props: {
        contaFlex: {
            type: Object,
            default: (_) => null,
        },
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes(
                "VEN_FLEX_LANCAMENTO"
            ),
            service: new FlexLancamentoService(this.$http, this.$router),
            motivoService: new MotivoService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            isSaving: false,
            validation: new FlexLancamentoValidation(),
            accessDenied: false,
            isNull: this.isNull,
            motivoList: [],
            motivoSelected: null,
            motivoLoading: false,
            isChanged: false,
            flexLancamento: {
                idVenFlex: 0,
                idMotivo: null,
                observacao: null,
                idPedido: 0,
                idPedidoRetorno: 0,
                idFatura: 0,
            },
        };
    },
    watch: {
        flexLancamento() {
            this.isChanged = true;
        },
        motivoSelected(newValue) {
            const handleNullNewValue = newValue ? newValue.id : null;

            this.flexLancamento.idMotivo = handleNullNewValue;
        },
    },
    created() {
        this.flexLancamento.idVenFlex = this.contaFlex.id;

        this.permissao = this.hasPermissionAccess(
            "vendas",
            "financeiro",
            "flex"
        );

        if (!this.permissao.create) {
            this.accessDenied = true;
        }
    },
    methods: {
        save() {
            this.isLoading = true;

            if (!this.validation.validate(this.flexLancamento, this.$refs)) {
                this.$root.showMessage(
                    "alert",
                    "msg-campos-obrigatorios",
                    true
                );
                this.isLoading = false;
                return;
            }

            this.flexLancamento.saldoLiberado = this.flexLancamento.saldoGerado;

            this.isSaving = true;

            this.service
                .save(this.flexLancamento)
                .then((value) => {
                    if (value.message == null) {
                        const msg = this.$t("saldo-adicionado-sucesso");

                        this.$root.showMessage("success", msg, true, false);
                        this.$emit("saved");
                    } else {
                        if (this.$t(value.message)) {
                            this.$root.showMessage(
                                "alert",
                                value.message,
                                true
                            );
                        } else {
                            this.$root.showMessage(
                                "error",
                                "msg-problema-realizar-acao",
                                true
                            );
                        }
                    }
                })
                .catch((e) => {
                    const responseBodyValidation =
                        e.body &&
                        !this.isNull(e.body.message) &&
                        this.$te(e.body.message);

                    if (responseBodyValidation) {
                        this.$root.showMessage(
                            "alert",
                            this.$t(e.body.message),
                            true,
                            false
                        );
                    } else {
                        this.$root.showMessage(
                            "error",
                            "msg-problema-realizar-acao",
                            true
                        );
                    }
                })
                .finally(() => {
                    this.isSaving = false;
                    this.isLoading = false;
                });
        },
        carregarMotivo() {
            this.motivoLoading = true;
            this.motivoService
                .findAll("motivo", "desc", 0, 10000, 1, [
                    ".*",
                    "CONTA_CORRENTE_FLEX",
                ])
                .then((response) => {
                    this.motivoList = response.content
                        .filter(({ inicio: isMotivoInicio }) => !isMotivoInicio)
                        .map(
                        ({
                            id,
                            descricao: label,
                            cor,
                            icone,
                            habilitaobrigaobservacao,
                            inicio,
                        }) => ({
                            id,
                            label,
                            cor,
                            icone: icone.toLowerCase(),
                            habilitaobrigaobservacao,
                            inicio,
                        })
                    );
                })
                .catch((e) => {
                    this.$root.showMessage("error", "msg-erro-load", true);
                })
                .finally((_) => {
                    this.motivoLoading = false;
                });
        },
        showConfirmModal() {
            if (this.isChanged) {
                this.$root.confirm({
                    message: this.$t('msg-tem-certeza-alteracoes'),
                    onConfirm: (_) => {
                        this.$emit('voltar', true);
                    },
                    onCancel: (_) => {
                        return;
                    },
                });
            } else {
                this.$emit('voltar', true);
            }
        }
    },
};
</script>
<style lang="scss" scoped>
.label-required {
    color: var(--primary-color);
}
.g-1 {
    gap: 4px;
}
#main {
    padding: 0 20px;
    height: auto;
    .page {
        position: relative;
        padding-left: 0;
    }
    .sovis-container-user {
        cursor: pointer;
        padding: 2px 10px;
        border: solid 1px $primary-color;
        background-color: #f0f0f0;
        border-radius: 6px;
        display: flex;
        .qtd-users {
            font-weight: bolder;
            font-size: 18px;
            margin: 0 10px;
            &.is-success {
                color: $green-alert;
            }
            &.is-danger {
                color: $orange;
            }
        }
    }
}
</style>
